<template>
  <div class="works_content" v-loading="loading">
    <Breadcrumb />
    <el-container class="main_box" id="works">
      <el-main class="main_info" v-if="isworks">
        <ul class="works_list clearfix">
          <li @click="RouteGo('NowManager')">
            <i class="icon i_group27"></i>
            <!-- <i class="icon new"></i> -->
            <strong>现任管理</strong>
          </li>
          <li @click="RouteGo('PastManager')">
            <i class="icon i_group27"></i>
            <!-- <i class="icon new"></i> -->
            <strong>历届管理</strong>
          </li>
          <!-- <li @click="RouteGo('DataManagement')">
            <i class="icon i_group27"></i>
            <strong>基本信息设置</strong>
          </li> -->
          <li @click="RouteGo('Notice')">
            <i class="icon i_group27"></i>
            <!-- <i class="icon new"></i> -->
            <strong>消息通知</strong>
          </li>
          <!-- <li @click="RouteGo('Statistics')">
            <i class="icon i_group1"></i>
            <i class="icon new"></i>
            <strong>支部分布情况图示</strong>
          </li> -->
          <li @click="RouteGo('System')">
            <i class="icon i_group27"></i>
            <!-- <i class="icon new"></i> -->
            <strong>常用功能设置</strong>
          </li>
          <li @click="RouteGo('password')">
            <i class="icon i_group27"></i>
            <!-- <i class="icon new"></i> -->
            <strong>密码修改</strong>
          </li>
          <li @click="RouteGo('BranchManagement')" v-if="!$store.state.IsBranch">
            <i class="icon i_group27"></i>
            <strong>支部账号管理</strong>
          </li>
          <li @click="RouteGo('geographical')" v-if="top_level || $store.state.IsBranch">
            <i class="icon i_group27"></i>
            <strong>系统功能设置</strong>
          </li>
          <li @click="RouteGo('LargeScreenHome')" v-if="visit_screen">
            <i class="icon i_group27"></i>
            <strong>数据可视化设置</strong>
          </li>
          <!-- <li @click="RouteGo('SysLogout')">
            <i class="icon i_group1"></i>
            <strong>退出账户</strong>
          </li> -->
        </ul>
      </el-main>
      <el-main v-else>
        <el-container>
          <el-aside class="works_side" width="14%">
            <div class="shadow_box hc_card">
              <!-- <h3>{{SideTitle}}</h3> -->
              <Sidebar />
            </div>
          </el-aside>
          <el-main class="nopadding">
            <router-view></router-view>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
  </div>
</template>
<script>
  import Sidebar from '@/components/Sidebar'
  import Breadcrumb from '@/components/Breadcrumb'
  export default {
    data() {
      return {
        loading: true,
        isworks: true,
        MenuList: [],
        SideTitle: null,
        visit_screen: false,
        top_level: false
      }
    },
    watch: {
      '$route'(to, from) {
        this.isworks = to.meta.moudles === true ? true : false
        //console.log(to.meta.title)
      }
    },
    components: { Sidebar, Breadcrumb },
    methods: {
      getMeta() {
        this.isworks = this.$route.meta.moudles === true ? true : false
        this.loading = false
      },
      topath(url) {
        this.$router.push(url);
      },
      async getauthority() {
        let userinfodata = await this.PublicApi("admin/base/getUserInfo")
        if (userinfodata.data.top_id == 0) {
          this.visit_screen = true;
        }
        else if (userinfodata.data.visit_screen == 1) {
          this.visit_screen = true;
        }
        else {
          this.visit_screen = false;
        }
          //设置是否是领头羊
          this.$setSession("is_top_public", userinfodata.data.is_top_public)
      }
    },
    mounted() {
      this.top_level = JSON.parse(sessionStorage.getItem('TOPLEVEL'));
      this.getMeta()
      this.getauthority();
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Management/index.vue